import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import DownloadMessage from "../../../../common/DownloadMessage/DownloadMessage";
import DownloadIcon from "../../../../Icon-SVG/DownloadIcon";
import Backdrop from "../../../../UI/Backdrop/Backdrop";
import { addNotification } from "../../../../../store/actions/notifierActions";
import axiosApi from "../../../../../utils/axios";

import "./styles.scss";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const AdditionalDetailsSidebar = ({ menuItems, activeMenu, onMenuItemSelect }) => {
  const dispatch = useDispatch();
  let query = useQuery();

  const [downloadOptions, setDownloadOptions] = useState({
    loaded: 0,
    total: 0,
    progress: 0,
    downloadStarted: false,
  });

  const generalInfo = useSelector((state) => state.analysisReports.general);

  const downloadFileName = `art_${generalInfo?.sha1}.gz`;

  const downloadArtifactFilesHandler = async () => {
    const options = {
      onDownloadProgress: (progressEvent) => {
        const { loaded, total, progress } = progressEvent;
        setDownloadOptions({ loaded, total, progress: progress * 100, downloadStarted: true });
      },
    };
    try {
      const response = await axiosApi.get(
        `/api/completed/artefacts/download/${query.get("data")}`,
        {
          responseType: "blob",
          ...options,
        },
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", downloadFileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (err) {
      dispatch(addNotification({ message: "Error", options: { variant: "error" } }));
    } finally {
      setTimeout(() => {
        setDownloadOptions((options) => ({ ...options, downloadStarted: false }));
      }, 2000);
    }
  };

  return (
    <div className="iocs__sidebar">
      <button className="android__download_artifacts" onClick={downloadArtifactFilesHandler}>
        Download Artifact Files <DownloadIcon width={18} />
      </button>
      {menuItems.map((menuItem) => (
        <button
          className={`iocs__sidebar__menu-item ${
            activeMenu.id === menuItem.id ? "iocs__sidebar__menu-item--active" : ""
          }`}
          key={menuItem.id}
          onClick={() => onMenuItemSelect(menuItem)}>
          {menuItem.header}
          {menuItem.countable ? <span>({menuItem.count})</span> : null}
        </button>
      ))}
      <Backdrop
        show={downloadOptions.downloadStarted}
        message={
          <DownloadMessage
            fileName={downloadFileName}
            loaded={downloadOptions.loaded}
            total={downloadOptions.total}
            progress={downloadOptions.progress}
          />
        }
      />
    </div>
  );
};

export default AdditionalDetailsSidebar;
